/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaToggle from 'DesignSystem/TysiaToggle/index'
import TysiaToggleButton from 'DesignSystem/TysiaToggle/TysiaToggleButton/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectApps/App/Content/Connections/Content/ActionsColumn/ToggleLocationConnection/CompleteSetupAction/Content"
  
}) {
let connectionValueData = fromData.useDataValue({ viewPath,
context: 'connection',
})
let aggregateData = fromHelpers.isConnectionDisabled(connectionValueData)
let onChange = fromHelpers.useOnClick({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<TysiaToggle
  viewPath={`${viewPath}/TysiaToggle`}
 marginLeft="auto"
 marginTop={0}
 value={false}
 onChange={onChange}
 data="connection"
 aggregate="helpers.js isConnectionDisabled"
 disabled={aggregateData}
>
{childProps => (
<TysiaToggleButton
{...childProps}
  viewPath={`${viewPath}/TysiaToggleButton`}
/>
)}
</TysiaToggle>
{children}
</React.Fragment>)
}